import React, { useEffect, useState } from "react";
import appel from "../../../assets/icons/apple.svg";
import mada from "../../../assets/icons/mada.svg";
import mc from "../../../assets/icons/mc.svg";
import qitaf from "../../../assets/icons/qitaf.png";
import visa from "../../../assets/icons/visa.svg";
import { Alert, Col, Divider, Form, Row } from "antd";
import Inputs from "../../../biblio/Inputs/Inputs";
import PrimaryButton from "../../../biblio/Buttons/PrimaryButton";
import MoyasarForm from "../../../components/Moyasar/MoyasarForm";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../apis/store";
import { setMobile, setParticipants } from "../../../apis/slices/moyasarSlice";

interface DonationPalmCardProps {
  palms: any;
}

const DonationPalmCard = ({ palms }: DonationPalmCardProps) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch<AppDispatch>();
  const [totalAmount, setTotalAmount] = useState<number>(0);
  const [shareNumber, setShareNumber] = useState<number>(1);
  const [contributorsNumber, setContributorsNumber] = useState<number>(1);
  const [contributorNumber, setContributorNumber] = useState<number>(1);
  const [displayMoyasar, setDisplayMoyasar] = useState<boolean>(false);
  const [required, setRequired] = useState<any[]>([]);
  const [displayError, setDisplayError] = useState<string>("");

  useEffect(() => {
    const calculatedAmount = shareNumber * (palms.share_amount || 0);
    setTotalAmount(calculatedAmount);
  }, [shareNumber, palms.share_amount]);

  const handleChangeSharesAmount = (value: number) => {
    setShareNumber(value);
    setTotalAmount(value * palms.share_amount);

    if (contributorsNumber > value) {
      setContributorsNumber(value);
    } else if (contributorNumber > value) {
      setContributorNumber(value);
    }
  };

  const handleChangeNumberOfContributors = (value: number) => {
    setContributorsNumber(Math.min(value, shareNumber));
  };

  const handleChangeNumberOfContributor = (value: number, index: number) => {
    let total = 0;
    Array.from({ length: contributorsNumber }).forEach((_, i) => {
      if (i !== index)
        total += parseInt(form.getFieldValue(`share_number${i}`) || 0);
    });
    if (total + value > shareNumber) {
      form.setFieldValue(`share_number${index}`, shareNumber - total);
    }
    setRequired(isRequired());
    form.validateFields();
  };

  const isRequired = () => {
    let total = 0;
    setDisplayError("");
    const list: any[] = [];
    Array.from({ length: contributorsNumber }).forEach((_, i) => {
      total += parseInt(form.getFieldValue(`share_number${i}`) || 0);
    });
    Array.from({ length: contributorsNumber }).forEach((_, i) => {
      const shareValue = parseInt(
        form.getFieldValue(`share_number${i}`) || "0"
      );
      if (total >= shareNumber) {
        list.push(shareValue !== 0);
      } else {
        list.push(true);
      }
    });

    return list;
  };

  useEffect(() => {
    setRequired(isRequired());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contributorsNumber]);

  const handleSubmit = async () => {
    try {
      await form.validateFields();
      const formValues = form.getFieldsValue();
      const participants = Array.from({ length: contributorsNumber })
        .map((_, index) => ({
          name: formValues[`name${index}`],
          share_number: formValues[`share_number${index}`],
          mobile: formValues[`mobile${index}`],
        }))
        .filter((participant) => participant.share_number > 0);

      const totalShares = participants.reduce((acc, participant) => {
        return acc + parseInt(participant.share_number || 0);
      }, 0);
      if (totalShares !== shareNumber) {
        setDisplayError("مجموع الأسهم لا يساوي العدد الإجمالي للأسهم");
      } else {
        setDisplayMoyasar(true);
        dispatch(setParticipants(participants));
        dispatch(setMobile(form.getFieldValue("mobileNumber")));
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className={`takaful--donation`}>
      <div className={"takaful--payment-card"}>
        <div className="takaful--donation-payment">
          <img className={`takaful--icon-btn`} src={mada} alt="" />
          <img className={`takaful--icon-btn`} src={mc} alt="" />
          <img className={`takaful--icon-btn`} src={visa} alt="" />
          <img className={`takaful--icon-btn`} src={appel} alt="" />
          <img className={`takaful--icon-btn`} src={qitaf} alt="" />
        </div>
        <Divider className="takaful--donation-divider" />
        <Form form={form} layout="horizontal" style={{ padding: "0.25rem" }}>
          <Row justify={"space-between"}>
            <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
              <span className="takaful--card-donation-palm-title">
                عدد الأسهم
              </span>
            </Col>
            <Col xxl={5} xl={5} lg={5} md={5} sm={5} xs={5}>
              <Form.Item>
                <Inputs
                  sizeInput="small"
                  withArrow={true}
                  className={`takaful--donation-input 
                       "takaful--input-payment-with-arrows"
                     
                  }`}
                  type="number"
                  style={{
                    height: "33px",
                    padding: "0 11px 0 0",
                    fontSize: "1rem",
                  }}
                  min={1}
                  maxLength={7}
                  value={shareNumber}
                  onChange={(e) => {
                    const value = Number(e.target.value);
                    if (value >= 1) handleChangeSharesAmount(value);
                  }}
                />
              </Form.Item>
            </Col>
            <Col xxl={2} xl={2} lg={2} md={1} sm={1} xs={1} />
            <Col xxl={6} xl={6} lg={6} md={7} sm={7} xs={7}>
              <span className="takaful--card-donation-palm-title">
                عدد المساهمين
              </span>
            </Col>
            <Col xxl={5} xl={5} lg={5} md={5} sm={5} xs={5}>
              <Form.Item>
                <Inputs
                  sizeInput="small"
                  withArrow={true}
                  className={`takaful--donation-input 
                       "takaful--input-payment-with-arrows"
                     
                  }`}
                  type="number"
                  style={{
                    height: "33px",
                    padding: "0 11px 0 0",
                    fontSize: "1rem",
                  }}
                  min={1}
                  value={contributorsNumber}
                  onChange={(e) => {
                    const value = Number(e.target.value);
                    if (value >= 1) handleChangeNumberOfContributors(value);
                  }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
              <span className="takaful--card-donation-palm-title">
                مبلغ الإجمالي
              </span>
            </Col>
            <Col xxl={18} xl={18} lg={18} md={18} sm={18} xs={18}>
              <Form.Item>
                <div className="takaful--donation-input-with-prefix">
                  <Inputs
                    style={{
                      fontSize: "1.2rem",
                      border: "none",
                      height: "100%",
                      borderRadius: " 0 7px 7px 0",
                    }}
                    sizeInput="small"
                    disabled
                    value={totalAmount.toString()}
                  />
                  <span className="takaful--donation-prefix icon-saudi_riyal">
                    {" "}
                  </span>
                </div>
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
              <span className="takaful--card-donation-palm-title">الجوال</span>
            </Col>
            <Col xxl={18} xl={18} lg={18} md={18} sm={18} xs={18}>
              <Form.Item name="mobileNumber">
                <Inputs
                  sizeInput="small"
                  type="tel"
                  maxLength={10}
                  placeholder="05XXXXXXXX"
                />
              </Form.Item>
            </Col>
          </Row>

          <h3 className="takaful--card-donation-palm-title-fields">
            بيانات المساهمين
          </h3>

          {Array.from({ length: contributorsNumber }).map((_, index) => (
            <div key={index}>
              <Row gutter={8} style={{ marginTop: "1rem" }}>
                <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                  <span className="takaful--card-donation-palm-title">
                    المساهم {index + 1}
                  </span>
                </Col>
                <Col xxl={13} xl={13} lg={13} md={13} sm={13} xs={13}>
                  <Form.Item
                    name={`name${index}`}
                    rules={[{ required: required[index], message: " " }]}
                  >
                    <Inputs sizeInput="small" />
                  </Form.Item>
                </Col>
                <Col xxl={5} xl={5} lg={5} md={5} sm={5} xs={5}>
                  <Form.Item
                    name={`share_number${index}`}
                    rules={[{ required: required[index], message: " " }]}
                  >
                    <Inputs
                      sizeInput="small"
                      withArrow={true}
                      className={`takaful--donation-input 
                       "takaful--input-payment-with-arrows"
                  }`}
                      type="number"
                      style={{
                        height: "32px",
                        padding: "0 11px 0 0",
                        fontSize: "1rem",
                      }}
                      min={1}
                      onChange={(e) => {
                        const value = Number(e.target.value);
                        handleChangeNumberOfContributor(value, index);
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                  <span className="takaful--card-donation-palm-title">
                    الجوال
                  </span>
                </Col>
                <Col xxl={18} xl={18} lg={18} md={18} sm={18} xs={18}>
                  <Form.Item
                    name={`mobile${index}`}
                    rules={[{ required: required[index], message: "" }]}
                  >
                    <Inputs sizeInput="small" type="tel" />
                  </Form.Item>
                </Col>
              </Row>
            </div>
          ))}

          <p
            style={{ textAlign: "right" }}
            className="takaful--donation-card-text"
          >
            بإتمام التبرع أنت توافق على&nbsp;
            <span style={{ color: "#02AB0A", cursor: "pointer" }}>
              سياسة المساهمة
            </span>
          </p>
        </Form>
        {displayError && (
          <div style={{ margin: "0 auto" }}>
            <Alert
              message={
                <div className="takaful--login-error-message">
                  <span>{displayError}</span>
                </div>
              }
              type="error"
              onClose={() => setDisplayError("")}
            />
          </div>
        )}

        <PrimaryButton
          className="takaful--donation-btn"
          title="ساهم الآن"
          onClick={() => handleSubmit()}
          disabled={
            // eslint-disable-next-line eqeqeq
            totalAmount == 0 || isNaN(totalAmount)
          }
        />
      </div>
      <MoyasarForm
        amount={totalAmount}
        description="Takaful"
        open={displayMoyasar}
        handleClose={() => setDisplayMoyasar(false)}
      />
    </div>
  );
};

export default DonationPalmCard;
